import { useSelector } from "react-redux";
import Drawer from "../../components/MenuDrawer/Drawer";
import {
  selectUserData,
  selectUserMenuFiltered,
  setUserMenuFiltered,
} from "../../features/userSlice";
import { useEffect } from "react";
import store from "../../store";
import { MENU_CONFIG } from "../../data/menu/MenuModule";
import { checkVisibility } from "../../logic/Menu/filterMenuPermissions";

export function DrawerScreen() {
  const userMenuFiltered = useSelector(selectUserMenuFiltered);
  const userData = useSelector(selectUserData);
  const userDataPermissions = userData?.data?.products;

  useEffect(() => {
    const visibleMenu = checkVisibility(MENU_CONFIG, userDataPermissions);
    store.dispatch(setUserMenuFiltered(visibleMenu));
    // eslint-disable-next-line
  }, []);

  return <>{userMenuFiltered?.length !== undefined ? <Drawer /> : ""}</>;
}
